import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import { Toaster } from "@/components/ui/sonner"
import { ErrorBoundary } from "./components/error-boundary"
import { CreatePage } from "./routes/create"
import { HomePage } from "./routes/home"
import { HowToPlayPage } from "./routes/how-to-play"
import { JoinPage } from "./routes/join"
import { RoomPage } from "./routes/room"
import { SettingsPage } from "./routes/settings"

function App() {
  return (
    <>
      <BrowserRouter>
        <ErrorBoundary>
          <a
            href="#main"
            className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-md focus:bg-popover focus:px-4 focus:py-2 focus:text-sm focus:text-popover-foreground focus:ring-2 focus:ring-ring"
          >
            Skip to main content
          </a>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-to-play" element={<HowToPlayPage />} />
            <Route path="/create" element={<CreatePage />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/r/:code" element={<RoomPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster />
    </>
  )
}

export default App
